export default __webpack_public_path__ + "static/media/logo_horizontal.90a56595.svg";